export const ImagesGalleryFilterEnum = {
  Country: {
    key: 1,
    value: 'country',
    lookupType: 'Country',
  },
  City: {
    key: 2,
    value: 'city',
    lookupType: 'City',
  },
  District: {
    key: 3,
    value: 'district',
    lookupType: 'District',
  },
  Community: {
    key: 4,
    value: 'community',
    lookupType: 'Community',
  },
  Subcommunity: {
    key: 5,
    value: 'sub-community',
    lookupType: 'SubCommunity',
  },
};
